import { render, staticRenderFns } from "./PopupContentPage.vue?vue&type=template&id=2a52924c"
import script from "./PopupContentPage.vue?vue&type=script&lang=js"
export * from "./PopupContentPage.vue?vue&type=script&lang=js"
import style0 from "./PopupContentPage.vue?vue&type=style&index=0&id=2a52924c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports